import { makeStyles } from "@material-ui/core/styles";

export const useAppSearchStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    background: "#ffffff",
  },
  closeIcon: {
    width: 60,
    height: 60,
  },
  dialog: {
    "& .MuiDialog-paperFullScreen": {
      position: "absolute",
      top: 0,
      height: "auto",
      "max-height": "100%",
    },
  },
  dialogContent: {
    padding: "20px 24px 8px",
  },
  error: {
    "font-size": "16px",
    "& .MuiAlertTitle-root": {
      "font-size": "18px",
    },
  },
  popper: {
    "z-index": 1301,
    width: "80%",
  },
  searchInput: {
    "flex-grow": "1",
    "margin-right": "24px",
    "& .MuiOutlinedInput-root": {
      "border-radius": "50px",
    },
    "& input": {
      "font-size": "1.8rem",
      padding: "10px 14px 10px 0",
    },
  },
  searchRow: {
    display: "flex",
    "align-items": "center",
    "justify-content": "space-between",
    width: "100%",
    padding: "15px 0 0",
  },
  suggestion: {
    padding: "5px 10px",
    cursor: "pointer",
    "&:hover": {
      background: "#00CAFF",
    },
  },
  tab: {
    "&:hover": {
      color: "#00CAFF",
    },
  },
  tables: {
    padding: "0 20px",
  },
  toolbar: {
    "flex-direction": "column",
    "align-items": "center",
  },
}));
